import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import TextInput from "./text-input";
import { updateSelectedOptionValueByKey } from "../../customisation-slice";

const propTypes = {
  selectedOption: PropTypes.instanceOf(Object),
};

const EngravingView = ({ selectedOption }) => {
  const dispatch = useDispatch();

  return (
    <div className="h-full">
      <TextInput
        title="Add your engraving"
        instruction="Max. 20 alphanumeric characters (letters A–Z, numbers 0–9)"
        value={selectedOption.text}
        onChange={(event) =>
          dispatch(
            updateSelectedOptionValueByKey({
              valueKey: "text",
              value: event.target.value.replace(/[^a-z0-9 ]/gi, ""),
            })
          )
        }
        maxLength={20}
      />
    </div>
  );
};

EngravingView.propTypes = propTypes;

export default EngravingView;
